import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    pure: true,
    standalone: false
})
export class TruncatePipe implements PipeTransform {
    transform(text: string, maxLength: number, wordwise: boolean = false, tail: string = '…'): string {
        if (!text) return '';

        maxLength = parseInt(maxLength?.toString(), 10);
        if (!maxLength || text.length <= maxLength) return text;

        if (wordwise) {
            const lastSpace = text.lastIndexOf(' ', maxLength);
            text = text.substring(0, lastSpace !== -1 ? lastSpace : maxLength);
        } else {
            text = text.substring(0, maxLength);
        }

        return text + (tail || '…');
    }
}
